var ES6Promise = require("es6-promise");
ES6Promise.polyfill();
import lottie from 'lottie-web';
import {fetch} from 'whatwg-fetch'
import AOS from 'aos';
import {tns} from "tiny-slider/src/tiny-slider";
import "tiny-slider/dist/tiny-slider.css";
import "scroll-watcher";
import CC from "cookieconsent";

import Vue from "vue";
import VShowSlide from 'v-show-slide'
import {FunctionalCalendar} from 'vue-functional-calendar';
import axios from "axios";

Vue.use(VShowSlide)


document.addEventListener("DOMContentLoaded", function (event) {

    const watcher = new ScrollWatcher();
    let lastScroll = 0;
    watcher.on("scrolling", function (evt) {
        const direction = evt.scrollY - lastScroll;
        if (evt.scrollY > 100 && direction > 0) {
            document.body.classList.add('body--scrolled');
        } else {
            document.body.classList.remove('body--scrolled');
        }
        lastScroll = evt.scrollY;
    });

    if (document.getElementById("accordeon")) {
        const topicList = new Vue({
            el: '#accordeon',
            data: {},
            methods: {}
        })
    }


    // Mobile menu
    document.getElementById("menu-toggle").addEventListener("click", () => {
        document.body.classList.toggle("body--showmenu")
    })

    // Map links
    var mapLinks = document.querySelectorAll('[data-maplink]');
    let current = null;

    const updateHovers = (id) => {
        if (current !== null) {
            [...document.querySelectorAll('[data-maplink="' + current + '"]')].forEach((link) => {
                link.classList.remove('maplink--hover');
            })
        }
        current = id;
        if (id !== null) {
            [...document.querySelectorAll('[data-maplink="' + id + '"]')].forEach((link) => {
                link.classList.add('maplink--hover');
            })
        }
    }

    if (mapLinks.length)
        [...mapLinks].map(link => {
            link.addEventListener("mouseover", () => {
                const id = link.getAttribute("data-maplink");
                if (current !== id) {
                    updateHovers(id);
                }
            });
            link.addEventListener("mouseout", () => {
                updateHovers(null);
            })
        })


    // Sliders
    var sliders = document.querySelectorAll('[data-behaviour="slider"]');

    if (sliders.length)
        [...sliders].map(slider => {
            return tns({
                container: slider,
                items: 1,
                slideBy: 'page',
                navAsThumbnails: true,
                nav: true,
                controls: slider.getAttribute('data-arrows'),
                controlsText: ['&lt;', '&gt;'],
                mouseDrag: true,
                autoplay: slider.getAttribute('data-autoplay'),
                autoplayTimeout: 4000,
                speed: 500,
                autoplayHoverPause: true,
                autoplayButtonOutput: false,
            });
        })

    // Scroll effects
    AOS.init({
        anchorPlacement: 'bottom-bottom',
        duration: 600,
        easing: 'ease-in-out'
    });

    // Toggles
    var toggles = document.querySelectorAll('[data-behaviour="toggle-active"]');

    if (toggles.length)
        [...toggles].forEach((toggle) => {
            toggle.addEventListener("click", () => {
                toggle.parentNode.classList.toggle("section_nav--active");
            });
        })

    var toggles = document.querySelectorAll('[data-behaviour="toggle-active-grandparent"]');

    if (toggles.length)
        [...toggles].forEach((toggle) => {
            toggle.addEventListener("click", () => {
                toggle.parentNode.parentNode.classList.toggle("section_nav--active");
            });
        })

    // Instagram
    var instagram = document.querySelector('[data-behaviour="instagram"]');

    async function fetchInstagram(instagramContainer) {
        const instagramData = JSON.parse(await fetch('https://www.instagram.com/stiftungensparkasseholstein/')
            .then(response => response.text())
            .then(data => data.match(/<script type="text\/javascript">window\._sharedData = (.*)<\/script>/)[1].slice(0, -1)));

        const mediaArray = instagramData.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges.splice(0, 10)

        const res = [];

        for (let media of mediaArray) {
            const node = media.node

            // Process only if is an image
            if ((node.__typename && node.__typename !== 'GraphImage')) {
                continue
            }

            // console.log(node);

            const regex = /.*?(\.)(?=\s[A-Z])/;

            let title = node.edge_media_to_caption.edges[0]?.node?.text;
            let m = null;
            if ((m = regex.exec(title)) !== null) {
                title = m[0];
            }
            res.push({
                title: title,
                link: "https://www.instagram.com/p/" + node.shortcode,
                thumbnail: node.thumbnail_src,
            })
        }

        const html = res.splice(0, 4).map(entry => `
                <a class="entry" href="${entry.link}" target="_blank">
                    <img src="${entry.thumbnail}"/>
                    <p class="entry_caption">${entry.title}</p>
                </a>
        `).join('');

        instagramContainer.innerHTML = html;
    }

    if (instagram) {
        fetchInstagram(instagram);
    }

    // Cookie, Matomo
    var _paq = window._paq = window._paq || [];

    function addAnalytics() {
        var u = "//matomo.atw.io/";
        _paq.push(['setVisitorCookieTimeout', 2880]); // 2 days
        _paq.push(['setReferralCookieTimeout', 2880]); // 2 days
        _paq.push(['setSessionCookieTimeout', 0]); // session only
        _paq.push(["setTrackerUrl", u + "matomo.php"]);
        _paq.push(["setSiteId", "6"]);
        _paq.push(['enableHeartBeatTimer', 30]);
        _paq.push(["trackPageView"]);
        _paq.push(["enableLinkTracking"]);

        var d = document, g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
        g.type = "text/javascript";
        g.defer = true;
        g.async = true;
        g.src = u + "matomo.js";
        s.parentNode.insertBefore(g, s);

        console.log('MATOMO Tracking enabled')
    }

    function optOut() {
        _paq.push(["disableCookies"]);
        _paq.push(["deleteCookies"]);
        // location.reload();

        console.log('MATOMO Tracking disabled')
    }

    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "rgba(255, 255, 255, 0.95)",
                "text": "#3D3D3D",
            },
            "button": {
                "background": "#DA0000",
                "text": "#ffffff"
            }
        },
        "position": "bottom-right",
        "theme": "edgeless",
        "type": "opt-in",
        "content": {
            "message": "Wir verwenden Tracking-Cookies für anonymisierte Nutzungsstatistiken.",
            "allow": "Einverstanden",
            "deny": "Ablehnen",
            "link": "Mehr erfahren",
            "href": "/datenschutz",
            "policy": 'Cookie Einstellungen'
        },
        onInitialise: function (status) {
            var didConsent = this.hasConsented();
            if (didConsent) {
                addAnalytics();
            } else {
                optOut();
            }
        },
        onStatusChange: function (status, chosenBefore) {
            var didConsent = this.hasConsented();
            if (didConsent) {
                addAnalytics();
            } else {
                optOut();
            }
        },
        onRevokeChoice: function () {
            optOut();
        },
    });

    // Lotties
    var lotties = document.querySelectorAll('[data-behaviour="lottie"]');

    if (lotties.length)
        [...lotties].map(lottieItem => {
            var animation = lottie.loadAnimation({
                container: lottieItem,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: lottieItem.getAttribute('data-path')
            })
        })

    var filterSelects = document.querySelectorAll('[data-behaviour="filter-select"]');

    if (filterSelects.length)
        [...filterSelects].forEach(select => {
            select.addEventListener("change", () => {
                select.form.submit();
            })
        })

});


Vue.component('availability-calendar', {
    components: {
        FunctionalCalendar
    },
    props: [
        'excursion',
        'bookingurl'
    ],
    data: function () {
        return {
            calendarData: {},
            calendarConfigs: {
                sundayStart: false,
                dayNames: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
                monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                dateFormat: 'dd/mm/yyyy',
                isDatePicker: false,
                isDateRange: false,
                isMultiple: true,
                calendarsCount: 3,
                markedDates: [],
                hiddenElemets: ['leftAndRightDays'],
            },
            availabilityMap: {},
            currentInfo: '',
        }
    },
    mounted() {
        axios
            .get(this.bookingurl + '/availabilitymap/' + this.excursion + '/')
            .then(response => {
                this.availabilityMap = response.data.reduce((map, obj) => {
                    map[obj.date] = obj.available;
                    return map;
                }, {});
                this.calendarConfigs.markedDates = response.data.map(date => date.date);

                document.querySelectorAll('.item_calendar').forEach(item => {
                    item.addEventListener('mouseover', (e) => {
                        if(e.target.classList.contains('vfc-marked')) {
                            const currentDay = e.target;
                            currentDay.setAttribute('title',this.currentInfo);
                        }
                    })
                });
            })
    },
    methods: {
        dayClicked: function (day) {
            if (day.isMarked) {
                const pattern = /(\d{1,2})\/(\d{1,2})\/(\d{4})/;
                const date = day.date.replace(pattern, '$3-$2-$1');
                const dt = new Date(date);//.toISOString();//.split('T')[0];
                const dateString = new Date(dt.getTime() - (dt.getTimezoneOffset() * 60000))
                    .toISOString()
                    .split("T")[0];
                location.href = this.bookingurl + "/booking/?excursion=" + this.excursion + "&day=" + dateString;
            }
        },
        dayMouseOver: function (date) {
            const availability = this.availabilityMap[date];
            if (availability) {
                this.currentInfo = 'verfügbar für ' + availability + ((availability > 1) ? ' Gruppen' : ' Gruppe');
            }
        }
    },
    template: `
      <div v-if="calendarConfigs.markedDates.length">
      <FunctionalCalendar
          :configs="calendarConfigs"
          ref="Calendar"
          v-on:dayClicked="dayClicked"
          v-on:dayMouseOver="dayMouseOver"
      />
      </div>
      <p style="text-align: center;" v-else><strong>Im Moment sind keine Termine verfügbar.</strong></p>
    `
})